import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ChatCrewMessage {
  role: string;
  content: string;
  timestamp?: string;
}

export interface ChatCrewRequest {
  messages: ChatCrewMessage[];
}

export interface ChatCrewResponse {
  status: string;
  response: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatCrewService {
  private apiUrl = environment.fastApiBaseUrl + '/ai';

  constructor(private http: HttpClient) { }

  /**
   * Process conversation messages using ChatCrew
   * @param messages Array of conversation messages
   * @returns Observable with ChatCrew response
   */
  processConversation(messages: ChatCrewMessage[]): Observable<ChatCrewResponse> {
    const request: ChatCrewRequest = {
      messages: messages
    };

    return this.http.post<ChatCrewResponse>(`${this.apiUrl}/chat-crew`, request);
  }
} 